import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Nosotros',
  title: 'Somos ACOMA.',
  subtitle:
    'Una technology company chilena que construye software, integra sistemas y crea agentes de inteligencia artificial capaces de trabajar con los procesos reales de una empresa.',
  tags: ['IA', 'Software', 'Integraciones', 'Productos Digitales'],
  blocks: [
    {
      icon: 'ri-stack-line',
      title: 'Producto',
      desc: 'Entendemos que una aplicación debe resolver un problema y generar valor, no simplemente funcionar.',
    },
    {
      icon: 'ri-git-branch-line',
      title: 'Arquitectura',
      desc: 'Diseñamos pensando en crecimiento, mantenimiento e integración.',
    },
    {
      icon: 'ri-brain-line',
      title: 'IA aplicada',
      desc: 'Integramos inteligencia artificial donde realmente aporta valor.',
    },
    {
      icon: 'ri-building-4-line',
      title: 'Experiencia empresarial',
      desc: 'Entendemos sistemas ERP, procesos empresariales e integraciones complejas.',
    },
    {
      icon: 'ri-route-line',
      title: 'End-to-End',
      desc: 'Podemos participar desde la idea inicial hasta producción.',
    },
    {
      icon: 'ri-global-line',
      title: 'Hechos en Chile',
      desc: 'Acompañamos de cerca a startups, pymes y corporaciones en su transformación tecnológica.',
    },
  ],
  highlightTitle: 'Pensamos más allá del código.',
  highlightDesc:
    'ACOMA no vende solamente horas de desarrollo. Construye soluciones y productos tecnológicos completos que trabajan para tu negocio.',
};

export default function Nosotros() {
  return <ServicePage content={content} />;
}